import React, {FC} from 'react';
import {GxCheckbox} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import styles from '../../styles/index.module.scss';
import Select from '../../../../components/Select';
import {TYPE_REMIND_TASK} from '../../const';
import {months, weekDays} from '../../../../const/calendar';
import CalendarInput from '../../../../components/CalendarInput';
import dayjs from '../../../../utils/dayjs';

interface ITabGroupsReminder {
    flag: boolean;
    handleClickTab: (name: string)=>void;
    formik: any,
}
const cn = cnBind.bind(styles);

const TabGroupsReminder:FC<ITabGroupsReminder> = ({flag, handleClickTab,formik}) => {
    return (
        <div className={cn({
            'tab-group': true,
            'tab-group--active': flag
        })}>
            <div className={styles['tab-group--container']}>
                <h2>Напоминания</h2>
                <p className={styles['tab-group--action']}
                   onClick={() => handleClickTab('reminderTab')}>{flag ? 'Свернуть' : 'Развернуть'}</p>
            </div>
            <div className={cn(styles['form'], styles['tab-group--item'])}>
                <GxCheckbox
                    className={styles['form--type']}
                    checked={formik.values.is_remind}
                    onGx-change={(e: Record<string, any>) => formik.setFieldValue('is_remind', e.target.checked)}
                >
                    Напомнить:
                </GxCheckbox>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                    <span className={styles['label']}>Тип:</span>
                    <Select
                        options={TYPE_REMIND_TASK}
                        onChange={(selectedOption: any) => formik.setFieldValue('remind_type', selectedOption.value)}
                    />
                </div>
                <div
                    className={cn(styles['form--item'], styles['calendar'], styles['calendar__right-block'])}>
                    <span className={styles['calendar__label']}>Дата и время:</span>
                    <DatePicker
                        weekDays={weekDays}
                        months={months}
                        render={<CalendarInput />}
                        format="DD/MM/YYYY HH:mm:ss"
                        containerStyle={{
                            width: '100%'
                        }}
                        weekStartDayIndex={1}
                        plugins={[
                            <TimePicker position='bottom' />
                        ]}
                        onChange={(date: any) => formik.setFieldValue('remind_at', dayjs(date).utc().format())}
                    />
                </div>
            </div>
        </div>
    );
};

export default TabGroupsReminder;
